import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=7a1654ce&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=7a1654ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1654ce",
  null
  
)

export default component.exports